import { render, staticRenderFns } from "./PrijavaUGrupu.vue?vue&type=template&id=6edc9fc6&scoped=true&"
import script from "./PrijavaUGrupu.vue?vue&type=script&lang=js&"
export * from "./PrijavaUGrupu.vue?vue&type=script&lang=js&"
import style0 from "./PrijavaUGrupu.vue?vue&type=style&index=0&id=6edc9fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc9fc6",
  null
  
)

export default component.exports